import { getFunnelId, type FunnelVertical } from "@b2bportal/core-utilities";
import type { RawAxiosRequestConfig } from "axios";

/**
 * Header the RBC BFF reads the shopping funnel ID (RBC-2304) from, so fintech
 * offers and transactions are attributed to the funnel instead of the
 * authenticated session.
 */
export const FINTECH_FUNNEL_ID_HEADER = "X-Fintech-Funnel-Id";

/**
 * Adds the `X-Fintech-Funnel-Id` header for `vertical`'s current funnel to
 * `options`, leaving any headers the caller already set in place.
 *
 * `options` is returned untouched when no funnel is active for the vertical:
 * the header is never sent empty — the BFF rejects an empty value with a 400 —
 * so the backend falls back to the authenticated session ID.
 */
export const withFintechFunnelIdHeader = (
  vertical: FunnelVertical,
  options?: RawAxiosRequestConfig
): RawAxiosRequestConfig | undefined => {
  const funnelId = getFunnelId(vertical);

  if (funnelId == null || funnelId === "") {
    return options;
  }

  return {
    ...options,
    headers: {
      ...options?.headers,
      [FINTECH_FUNNEL_ID_HEADER]: funnelId,
    },
  };
};
